enum ADFSServer {
  Krungsri = "https://adfsuat.krungsri.com",
  OSD = "https://adfs-server.lab.local"
}

export const loginWithADFS = () => {
  const clientRequestId = "3ed88cd5-304f-4e06-0a00-0080000000c0"
  const authUrl = `${ADFSServer.OSD}/adfs/ls/idpinitiatedsignon?client-request-id=${clientRequestId}`
  window.location.replace(authUrl)
}